import { render, staticRenderFns } from "./OperationEditTab.vue?vue&type=template&id=08c79d20"
import script from "./OperationEditTab.vue?vue&type=script&lang=js"
export * from "./OperationEditTab.vue?vue&type=script&lang=js"
import style0 from "./OperationEditTab.vue?vue&type=style&index=0&id=08c79d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports